import { HttpParams } from '@angular/common/http';

export interface PaginatedRequest<TFilters = {}> {
	pagination?: {
		page?: number;
		limit?: number;
		sort_by?: string;
		sort_dir?: 'asc' | 'desc';
	};
	filters?: {
		search?: string;
		active_status?: 'all' | 'active' | 'inactive';
	} & TFilters;
}

export function buildPaginatedParams<T extends Record<string, any>>(request: PaginatedRequest<T>): HttpParams {
	let params = new HttpParams();
	const pagination = request.pagination || {};
	const filters = (request.filters || {}) as Record<string, any>;

	const setPageParam = (key: string, value: string) => {
		params = params.set(key, value);
	};

	if (pagination.page !== undefined) setPageParam('page', String(pagination.page));
	if (pagination.limit !== undefined) setPageParam('limit', String(pagination.limit));
	if (pagination.sort_by) setPageParam('sort_by', pagination.sort_by);
	if (pagination.sort_dir) setPageParam('sort_dir', pagination.sort_dir);

	for (const [key, value] of Object.entries(filters)) {
		params = appendFilterValue(params, `filters[${key}]`, value);
	}

	return params;
}

function appendFilterValue(params: HttpParams, key: string, value: any): HttpParams {
	if (value === undefined || value === null || value === '') return params;
	if (Array.isArray(value)) {
		if (value.length === 0) return params;
		value.forEach(v => {
			params = params.append(`${key}[]`, String(v));
		});
		return params;
	}
	if (typeof value === 'object') {
		for (const [k, v] of Object.entries(value)) {
			params = appendFilterValue(params, `${key}[${k}]`, v);
		}
		return params;
	}
	const paramValue = typeof value === 'boolean' ? (value ? '1' : '0') : String(value);
	return params.set(key, paramValue);
}
